const { version }: { version: string } = require('../../package.json');

export const environment = {
  VERSION: version,
  URI: 'https://api-rental-qa.sodimac-it.com/',
  URI_WSS: 'wss://api-rental-qa.sodimac-it.com/',
  URI_GRAPHQ: 'RentalDal/graphql',

  WARRANTY: {
    MAINTAINER: {
      USERS: { }
    },
    RECOVERY: {
      UNCOLLECTIBLE_CASE_SYMBOLOGY_ATTEMPTS: '24',
      CRITICAL_CASE_SYMBOLOGY_AMOUNT: '$5 millones',
      CRITICAL_CASE_SYMBOLOGY_ATTEMPTS: '16',
      MODERATE_CASE_SYMBOLOGY_AMOUNT: '$2 millones',
      MODERATE_CASE_SYMBOLOGY_ATTEMPTS: '15',
      LOW_CASE_SYMBOLOGY_AMOUNT: '$1',
      LOW_CASE_SYMBOLOGY_ATTEMPTS: '7',
      TOTAL_CRITICAL_CASES: '5',
      CSRF_TOKEN: 'busc-tlrt-api-core-rental/v1/automatic-warranty-payment/csrftoken',
      GET_CONTRACTS: 'busc-tlrt-api-core-rental/v1/automatic-warranty-payment/filter',
      EXPORT_CONTRACTS_TO_EXCEL: 'busc-tlrt-api-core-rental/v1/automatic-warranty-payment/export-contracts-to-excel',
      GET_AUTOPAY_CASES: 'busc-tlrt-api-core-rental/v1/autopay/autoPayCases',
    }
  },

  DEPRECIATION: {
    STORE: {
      UPDATE: 'api/rental-sap/api/check/process/event/saveCurrentState',
      GET: 'api/rental-sap/api/check/process/event/currentState',
    },
    STEPPER: {
      FIRST_STEP: {
        HISTORY: 'api/rental-sap/api/depreciation/dashboard/history',
        LOST_EVENTS_PERIOD: 'api/rental-sap/api/check/process/event/missed',
        WSS: {
          LOST_EVENTS_LOAD: 'rental-sap/depreciationStep1?id=',
        }
      },
      SECOND_STEP: {
        LOAD_SKU: 'api/rental-sap/api/check/loadsku?country=CL',
      },
      THIRD_STEP: {
        UPDATE_CAF: 'api/rental-sap/api/check/cargaCaf',
        WSS: {
          CAF_LOAD: 'rental-sap/depreciationStep3?id=',
        }
      },
      SKIP_EVENTS_STEP: {
        GET_SKIP_EVENTS: 'api/rental-sap/api/depreciation/skip-events/list',
        SET_SKIP_EVENT: 'api/rental-sap/api/depreciation/skip-events/skip',
        EXPORT_SKIP_EVENTS: 'api/rental-sap/api/depreciation/skip-events/export',
      },
      FOURTH_STEP: {
        REGISTERED: {
          GET_TOOLS: 'api/rental-sap/api/report/error/altas',
          CORRECT_TOOL: 'api/rental-sap/api/report/error/altas',
          REPROCESS_TOOLS: 'api/rental-sap/api/report/error/masiveAltas',
          REPROCESS_TOOL: 'api/rental-sap/api/updateToolAlta',
        },
        UNREGISTERED: {
          GET_TOOLS: 'api/rental-sap/api/report/error/bajas',
          CORRECT_TOOL: 'api/rental-sap/api/report/error/bajas',
          REPROCESS_TOOL: 'api/rental-sap/api/SAP/updateToolBaja',
        }
      },
      FIFTH_STEP: {
        SEND_REPORTS: 'api/rental-sap/api/report/sendReports',
        DOWNLOAD: {
          TOOLS_UNREGISTERED_REPORT_FILE: 'api/rental-sap/api/report/bajas',
          TOOLS_REGISTERED_REPORT_FILE: 'api/rental-sap/api/report/altas',
          TOOLS_MASTER_REPORT_FILE: 'api/rental-sap/api/report/master',
        }
      }
    }
  },
  OAUTH2: {
    LOGOUT_COUNTDOWN_TIME_MINUTES: 30,
    TOKEN_URL: 'rental-sap/oauth2/token',
    TOKEN_CLIENT_SECRET: 'Cg75OeWMscSZnbHeSHBm4PgYQo4hjUwL',
    TOKEN_GRANT_TYPE: 'client_credentials',
    TOKEN_CLIENT_ID: 'WKHAXbigTHPZsQE9NsIXS8vPghG7H4uh',
    URL: 'https://qa-access-key-corp.falabella.tech/auth/',
    REALM: 'corp',
    ID: 'socorp-stro-stcx-rental-apps'
  },
};
